<template>
	<ppe-form 
		entityName="OperationSubscription"
		title="Projet / Opération" 
		title-field="{operation.code} - {operation.operationname}"
 	  sub-title=""
		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_ee/operation_home_ee/:operationid'" 
		>

	</ppe-form>
</template>
<script>
 
import Utils    from '../ppe/utils'

export default {
	data() {
		console.log("this.$route.params.id", this.$route.params.id)
		return {
			endpoint : "/ee/operation_ee?accountid="+this.$route.params.accountid + (this.$route.params.id?'&id='+this.$route.params.id:''),
			schema : [
				
				
				Utils.getAdminCard(),

				Utils.getGetManagerCard({received:true}),
				
				],
				

		}
	},

};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}
</style>
